import { UzButton } from '@utazzo/ui';
import { Download } from 'lucide-react';
import React from 'react';

import { useDownloadSampleTemplate } from '../use-imports';

/**
 * One-line component every importer's Upload step drops next to the
 * "Pick XLSX" button. Calls the runtime template endpoint
 * `GET /imports/:moduleKey/template`, decodes the base64 blob, and
 * triggers a browser download.
 */
export const SampleTemplateButton = ({
  moduleKey,
  label = 'Download sample template',
}: {
  moduleKey: string;
  label?: string;
}): React.JSX.Element => {
  const download = useDownloadSampleTemplate();
  return (
    <UzButton
      variant="ghost"
      size="sm"
      loading={download.isPending}
      onClick={() => download.mutate(moduleKey)}
    >
      <Download className="mr-1.5 h-4 w-4" />
      {label}
    </UzButton>
  );
};
